import React from "react";
import "./DownloadApplication.css";
import DownloadMobile from "../../assets/DownloadMobile.webp";
import GooglePlay from "../../assets/GooglePlay.svg";
import AppStore from "../../assets/AppStore.svg";

const DownloadApplication = () => {
  return (
    <div className="downloadApp flex absoluteCenter">
      <img src={DownloadMobile} alt="Mobile App" title="App" className="appMobile cursorPointer" />
      <div className="flex column download">
        <div className="downloadDesc">
          <div className="firstLine">All this from the convenience of your phone.</div>
          <div className="secondLine">Download the Dunzo mobile app.</div>
        </div>
        <div>
          <img src={GooglePlay} alt="Google App" className="google cursorPointer" />
          <img src={AppStore} alt="Apple App" className="apple cursorPointer" />
        </div>
      </div>
    </div>
  );
};

export default DownloadApplication;
